function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCstmtu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9bd2a89-0842-46ff-aa70-4c92a1425ff1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a2d079e1-9c18-4024-b30f-a91e5c5c416d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-46.61-80.53h-21a1.09,1.09,0,0,1-1.09-1.09v-21a1.09,1.09,0,0,1,1.09-1.09h10.74a1.09,1.09,0,0,1,1.09,1.09,1.09,1.09,0,0,1-1.09,1.09h-9.66v18.79h18.8V-91a1.08,1.08,0,0,1,1.08-1.09A1.09,1.09,0,0,1-45.52-91v9.4a1.09,1.09,0,0,1-1.09,1.09",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be2b5d8b-9faf-4de8-98e4-90b1496d22a3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-56.61-86.53h-.07l-3.87-.25a1.08,1.08,0,0,1-1-1l-.25-3.87a1.06,1.06,0,0,1,.31-.82l10.88-10.89a1.1,1.1,0,0,1,.75-.31,1.11,1.11,0,0,1,.76.31L-45-99.24a1.07,1.07,0,0,1,.31.76,1.06,1.06,0,0,1-.31.75L-55.86-86.85A1.07,1.07,0,0,1-56.61-86.53Zm-2.87-2.33,2.46.17,9.79-9.79-2.63-2.63-9.79,9.79Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb0b61de-0fc0-455e-9e7f-9b793b6c42af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.55-102.75a4.76,4.76,0,0,0-6.36,2.39,5.69,5.69,0,0,0,0,3.82A4.75,4.75,0,0,0,89.13-94a5.24,5.24,0,0,0,2.6-2.33A5.47,5.47,0,0,0,92-100,5.55,5.55,0,0,0,89.55-102.75Zm-2.94-2.1a6.32,6.32,0,0,1,6.33,2.93,6.5,6.5,0,0,1-1.53,8.6,5.35,5.35,0,0,1-3.91,1.21,4.12,4.12,0,0,1-2.68-.54,6.41,6.41,0,0,1-3-8.69A6.52,6.52,0,0,1,86.61-104.85ZM99-96.11l1.31,1.27-2,2,2,1.94-.57.57a2.24,2.24,0,0,1-.73.58A5.14,5.14,0,0,1,98-90.66l-.9-.91-1,.93-.94.93-.63-.5c-.35-.28-.62-.57-.62-.66a4.55,4.55,0,0,1,.91-1.08l.92-.89-.92-.92a5.44,5.44,0,0,1-.91-1.06,2.85,2.85,0,0,1,.56-.71l.57-.58,2,2Zm-19,2.4,0,0a6.13,6.13,0,0,1,.49.69l.39.58-.79.75c-1.72,1.66-2,2.68-2,7,0,2.67,0,3.19.24,3.38s1,.23,6.76.24h3.6c5.94,0,7.94,0,8.07-.18a10.08,10.08,0,0,0,.18-3v-2.85h1.78v3.25c0,3.12-.15,3.55-1.14,4.17l-.57.35-9,0h-3.7c-3.68,0-5.62,0-6.05-.12a2.14,2.14,0,0,1-1.3-.74c-.52-.58-.67-1-.68-2.83v-.42c0-.52,0-1.14,0-1.89a15.16,15.16,0,0,1,.34-4l0-.18A8.56,8.56,0,0,1,79.08-93c.47-.43.9-.74,1-.66Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5c73921-1dca-4367-b3c3-cedac5a3e21f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15-99.11a4.87,4.87,0,0,0,0,3.24,4,4,0,0,0,5,2.17,4.4,4.4,0,0,0,2.2-2,4.7,4.7,0,0,0,.23-3.16,4.67,4.67,0,0,0-2.08-2.3A4,4,0,0,0,5.15-99.11Zm8.29-1.33a5.54,5.54,0,0,1-1.31,7.31,4.57,4.57,0,0,1-3.32,1,3.55,3.55,0,0,1-2.27-.45A5.45,5.45,0,0,1,4-99.94a5.54,5.54,0,0,1,4.07-3A5.36,5.36,0,0,1,13.44-100.44ZM21.67-96a.88.88,0,0,1,.87,0,1.17,1.17,0,0,1,.8,1.16v.06c0,.53.05.46-3.54,4.24-3.35,3.53-3.56,3.77-4,3.79h-.25c-.58,0-.73-.15-2-1.78s-1.4-1.78-1.4-2.11a1.34,1.34,0,0,1,.79-1.16c.7-.29,1-.14,2,1a10.18,10.18,0,0,0,.86,1c.16-.21,1.48-1.59,2.84-3l.37-.38L20-94.34l.33-.33C21.05-95.41,21.6-95.94,21.67-96ZM2.47-93.46h0a4.24,4.24,0,0,1,.36.5l.06.09.33.49-.67.64C1.1-90.32.85-89.46.85-85.8c0,2.26,0,2.7.2,2.87l0,0,0,0c.28.12,1.29.15,5.67.16H9.84c5.05,0,6.74,0,6.85-.15a7.32,7.32,0,0,0,.15-2.36v-1h1.51v1.07c0,2.57-.12,3-.89,3.48l-.08,0-.47.31-7.61,0H6.15c-3.12,0-4.77,0-5.13-.11A1.82,1.82,0,0,1-.09-82c-.43-.48-.56-.81-.57-2.39v-.36c0-.45,0-1,0-1.61a11.62,11.62,0,0,1,.33-3.57,7.24,7.24,0,0,1,2-3,3.21,3.21,0,0,1,.78-.57Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5aece92-be6e-4528-a0de-d770edb9e18b"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2.7,
    width: 28,
    height: 25,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6c3ffdc-2f35-4d80-957a-431fa213b535"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-80 85 -73.5 91.55 -74.94 93 -80 87.91 -85.06 93 -86.5 91.55 -80 85",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b0cb45a8-7085-42d3-ade6-c93a7c49ea13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-40 93 -46.5 86.45 -45.06 85 -40 90.09 -34.94 85 -33.5 86.45 -40 93",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -708.66,
    y: -185.61,
    width: 1528,
    height: 860,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a5aece92-be6e-4528-a0de-d770edb9e18b)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1.7,
    width: 30,
    height: 26.61,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.28,17.83H27c-1.39,0-1.39,0-1.74-1.31a8.41,8.41,0,0,0-4.53-5.41l.18-.29c.07-.1.16-.2.23-.31a4.76,4.76,0,0,0,.25-5.15A4.81,4.81,0,0,0,16.89,2.7a4.81,4.81,0,0,0-4.51,2.71,4.77,4.77,0,0,0,.34,5.21c.11.16.37.28.27.52a2.11,2.11,0,0,1-1.78.49,5.07,5.07,0,0,0-7.62,3.42,6.27,6.27,0,0,0,.23,2.78c-1,0-2,0-2.93,0C.4,17.82,0,18,0,18.5s.42.6.86.6c1.11,0,2.23,0,3.34,0,.18,0,.44-.12.54.24l-.67.37A8.11,8.11,0,0,0,0,26C-.08,27.12.1,27.3,1.17,27.3H15.89c1.24,0,1.43-.2,1.27-1.44A8.17,8.17,0,0,0,13,19.66c-.2-.12-.49-.16-.63-.56H24.77c.82,0,1.65,0,2.47,0,.43,0,.75-.17.76-.62S27.72,17.83,27.28,17.83Zm-16.07.86c-.93.87-.88,1.11.28,1.61A7,7,0,0,1,15.88,26H1.33a6.9,6.9,0,0,1,4.34-5.69c1.21-.53,1.26-.73.3-1.66a3.73,3.73,0,0,1-.1-5.37,3.83,3.83,0,0,1,5.48,0A3.73,3.73,0,0,1,11.21,18.69Zm12.45-.86H13.34a5.12,5.12,0,0,0-.69-5A4.62,4.62,0,0,1,14.16,12c.91-.38,1-.75.26-1.4a3.63,3.63,0,0,1-1.27-3.68A3.63,3.63,0,0,1,15.83,4.1a3.8,3.8,0,0,1,4.36,1.75,3.73,3.73,0,0,1-.69,4.62c-.95.9-.9,1.11.32,1.65a7,7,0,0,1,4.35,5.68Z",
    style: {
      fill: "#152b4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1.7,
    width: 30,
    height: 26,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2.7,
    width: 28,
    height: 24.61,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCstmtu);
export default __webpack_public_path__ + "static/media/cstmtu.d0e8b928bafa257ba313629276867193.svg";
export { ForwardRef as ReactComponent };